import { render } from "./UserDropdown.vue?vue&type=template&id=07119712&scoped=true"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"

import "./UserDropdown.vue?vue&type=style&index=0&id=07119712&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07119712"]])

export default __exports__